import type {
  ApplyGradeOverrideMutation,
  BatchUpdateResponseSgaSubmission,
  DeleteGradeOverrideMutation,
  SubmitGradesToGradeBookSgaSubmission,
} from 'bundles/grading/api/types';

export const isNullOrUndefined = (x: unknown): x is null | undefined => {
  return x === null || x === undefined;
};

/**
 * Helper type-guard function for BatchUpdateResponse
 * @param { BatchUpdateResponseSgaSubmission | SubmitGradesToGradeBookSgaSubmission } sgaSubmission
 * @returns is BatchUpdateResponseSgaSubmission
 */
export const isBatchUpdateResponse = (
  sgaSubmission: BatchUpdateResponseSgaSubmission | SubmitGradesToGradeBookSgaSubmission
): sgaSubmission is BatchUpdateResponseSgaSubmission => {
  // maxScore only exists in BatchUpdateResponse
  return (sgaSubmission as BatchUpdateResponseSgaSubmission).maxScore !== undefined;
};

/**
 * Helper type-guard function for BatchUpdateResponse
 * @param { BatchUpdateResponseSgaSubmission | SubmitGradesToGradeBookSgaSubmission } sgaSubmission
 * @returns is SubmitGradesToGradeBookSgaSubmission
 */

export const isSubmitGradesResponse = (
  sgaSubmission: BatchUpdateResponseSgaSubmission | SubmitGradesToGradeBookSgaSubmission
): sgaSubmission is SubmitGradesToGradeBookSgaSubmission => {
  // maxScore does not exist in SubmitGradesResponse
  return (sgaSubmission as BatchUpdateResponseSgaSubmission).maxScore === undefined;
};

/**
 * Helper type-guard function for ApplyGradeOverrideMutation
 * @param { ApplyGradeOverrideMutation | DeleteGradeOverrideMutation } sgaSubmission
 * @returns is ApplyGradeOverrideMutation
 */
export const isApplyGradeOverrideResponse = (
  gradeOverride: ApplyGradeOverrideMutation | DeleteGradeOverrideMutation
): gradeOverride is ApplyGradeOverrideMutation => {
  // GroupGrading_ApplyGradeOverride only exists here
  return (gradeOverride as ApplyGradeOverrideMutation).GroupGrading_ApplyGradeOverride !== undefined;
};

/**
 * Helper type-guard function for DeleteGradeOverrideMutation
 * @param { ApplyGradeOverrideMutation | DeleteGradeOverrideMutation } sgaSubmission
 * @returns is DeleteGradeOverride
 */
export const isDeleteGradeOverrideResponse = (
  gradeOverride: ApplyGradeOverrideMutation | DeleteGradeOverrideMutation
): gradeOverride is DeleteGradeOverrideMutation => {
  // GroupGrading_DeleteGradeOverride only exists here
  return (gradeOverride as DeleteGradeOverrideMutation).GroupGrading_DeleteGradeOverride !== undefined;
};
